export default {
  fillPriceList: "Fill out the price list",
  updatePriceList: "Update price list",
  "Studies available": "Available studies",
  "Studies limit about":
    "The number of studies that can be processed is limited. Contact your manager or sales@3opinion.ai to increase the limit",
  "Studies limit reached":
    "The limit of studies exceeded. Contact your manager or sales@3opinion.ai to increase the limit",
  "Wait for upload": "Wait for the current upload to finish",
  Upload: "Upload",
  directory: "Upload folder",
  zip: "Upload files",
  gender: "Sex, age",
  Name: "Description",
  Status: "AI Result",
  studyDate: "Study Date",
  uploadDate: "Upload Date",
  "Dicom count": "Instances",
  Action: "Action",
  Delete: "Delete",
  "Delete confirm": "Are you sure you want to delete the study?",
  "Delete confirm about":
    "When deleting, the research processing limit will not change",
  "No studies": "No studies are uploaded yet",
  Search: "Find",
  Cancel: "Reset",
  "Study status none": "Not started",
  "Study status process": "Processing",
  "Study status not_found": "Normal",
  "Study status found": "Abnormal",
  Wait: "Waiting",
  "Zip processed": "Compression",
  Done: "Done",
  "Success upload": "Files uploaded. wait for a study list refresh",
  "Upload error": "Server unavailable, try again later",
  "Reach files size":
    "Upload is impossible. Exceeded the allowed total weight of files",
  "Upload process": "Uploading",
  Yes: "Yes",
  No: "No",
  "Study in queue": "Queue",
  "Study in proccess": "Processing",
  "Study not found": "Pathology not found",
  "Study found": "Pathology found",
  "Study error": "Error",
  "Study error about": "Upload error, try again later",
  patientID: "Patient ID",
  male_short: "M",
  female_short: "F",
  "Wait for anonimization": "Anonymization",
  "Wait for loading": "Uploading",
  "Studies title": "Study list | " + process.env.VUE_APP_INSTALL_NAME + "",
  "Error upload":
    "The extensions of uploaded files does not meet the requirements",
  undefined__error:
    "The extensions of uploaded files does not meet the requirements",
  good: "Okay",
  step0:
    "You can upload a folder with studies, it will be anonymized and processed with AI",
  step1:
    "Your studies are uploading. It may take a few minutes. <br><br> The upload runs in the background. You can view other studies during this time.",
  step2:
    "The AI-processed series will appear here. <br><br> Processing may take a few minutes, it is running in the background. You can view other studies during this time.",
  "Demo Upload text": "Only verified users can import their studies",
  Register: "Register",
  "Demo Banner Text":
    "Create an account and process 10 of your " +
    process.env.VUE_APP_INSTALL_NAME +
    " for free",
  Okay: "Okay",
  "Mobile Notification":
    "Website is optimized to run on the Desktop Chrome browser",
  "Studies limit Demo about": "Only verified users can import their studies",
  "Dicom count v2": "Instances",
  prev: "Prev",
  next: "Next",
  "Files select": "Selected files",
  "Access files": "Suitable for service requirements",
  "Access files about": "They are uploaded to the server for AI-analysis",
  "Skip files": "Not suitable",
  "Tags values": "Tags",
  "Skip files about": "do not meet the service requirements",
  Check: "Check",
  "Status short": "Status",
  TagError: {
    tail: "<br><br> Choose another study",
    not_exist: "<TAG> not found",
    some_error:
      "<TAG> with <TAG_VALUE> doesn’t meet the service requirements <RULES>",
    PatientsAge: "Patient is under 18 years old",
    Modality: "Modality",
    SliceThickness: "Slice thickness",
    BodyPartExamined: "BodyPartExamined",
    StudyInstanceUID: "StudyInstanceUID",
    SeriesInstanceUID: "SeriesInstanceUID",
  },
};
